import { useFlagship } from "@flagship.io/react-sdk";
import type { AbTestContext, AbTestFlag, AbTestVariation } from "../types";

/**
 * Adapts the A/B testing vendor SDK into a vendor-agnostic context.
 * This is the only place coupled to the current provider; swap it to change vendor.
 */
export const useAbTests = (): AbTestContext => {
	const { getFlags, visitorId } = useFlagship();

	const flagsByVariation = [...getFlags()].reduce((groups, [key, flag]) => {
		const { variationName } = flag.metadata;
		const flags = groups.get(variationName) ?? [];
		flags.push({ key, value: flag.getValue(null, false) });
		return groups.set(variationName, flags);
	}, new Map<string, AbTestFlag[]>());

	const variations: AbTestVariation[] = [...flagsByVariation].map(([name, flags]) => ({
		name,
		flags,
	}));

	return { visitorId, variations };
};
